/**
 * Request schemas for Space Manage → Members (directory, kick, notes).
 *
 * @module schemas/space-member-directory
 */
import { z } from 'zod';
import { SPACE_MEMBER_KICK_REASON_MAX_LENGTH, SPACE_MEMBER_NOTE_MAX_LENGTH, } from '../api/space-member-directory';
/** Optional moderator reason; recorded in the audit log and former-member row. */
export const KickSpaceMemberSchema = z.object({
    reason: z.string().trim().max(SPACE_MEMBER_KICK_REASON_MAX_LENGTH).optional(),
});
export const CreateSpaceMemberNoteSchema = z.object({
    body: z.string().trim().min(1).max(SPACE_MEMBER_NOTE_MAX_LENGTH),
});
export const UpdateSpaceMemberNoteSchema = CreateSpaceMemberNoteSchema;
//# sourceMappingURL=space-member-directory.js.map